import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { IonicVue } from '@ionic/vue';
import './assets/tailwind.css'

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

import dayjs from 'dayjs';
import 'dayjs/locale/id'
import isoWeek from 'dayjs/plugin/isoWeek'
import isBetween from 'dayjs/plugin/isBetween'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import relativeTime from 'dayjs/plugin/relativeTime'
import duration from 'dayjs/plugin/duration'
import i18n from './locales'

dayjs.extend(duration);
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)
dayjs.extend(isoWeek)
dayjs.extend(isBetween)
dayjs.extend(relativeTime)
dayjs.locale('id')

import VueECharts from 'vue-echarts'
import { use } from 'echarts/core'
import { PieChart, BarChart } from 'echarts/charts'
import { CanvasRenderer } from 'echarts/renderers'
import { GridComponent, TooltipComponent, LegendComponent } from 'echarts/components'

import 'pinch-zoom-element';

use([PieChart, BarChart, GridComponent, TooltipComponent, LegendComponent, CanvasRenderer])

const app = createApp(App)

app.config.compilerOptions = {
  isCustomElement: (tag) => tag === 'pinch-zoom'
}

app
.use(i18n)
.use(store)
.use(IonicVue)
.component('v-chart', VueECharts)
.use(router)
.use(dayjs)
.provide('dayjs', dayjs)
.mount('#app')
